<template>
	<form>
		<md-field :class="[{ 'md-error': errors.has('firstName') }]">
			<label>{{ $t("common.firstName") }}</label>
			<md-input
				v-model="form.firstName"
				@input="onChange"
				data-vv-name="firstName"
				v-validate="modelValidations.firstName"
				autocomplete="representative-firstname"
				required
			></md-input>
			<span v-if="errors.has('firstName')" class="validation-error">{{ errors.first('firstName') }}</span>
		</md-field>
		<md-field :class="[{ 'md-error': errors.has('lastName') }]">
			<label>{{ $t("common.lastName") }}</label>
			<md-input
				v-model="form.lastName"
				@input="onChange"
				data-vv-name="lastName"
				v-validate="modelValidations.lastName"
				autocomplete="representative-lastname"
				required
			></md-input>
			<span v-if="errors.has('lastName')" class="validation-error">{{ errors.first('lastName') }}</span>
		</md-field>
		<md-field :class="[{ 'md-error': errors.has('email') }]">
			<label>{{ $t("common.email") }}</label>
			<md-input
				v-model="form.email"
				@input="onChange"
				data-vv-name="email"
				v-validate="modelValidations.email"
				type="email"
				autocomplete="representative-email"
				required
			></md-input>
			<span v-if="errors.has('email')" class="validation-error">{{ errors.first('email') }}</span>
		</md-field>
		<BirthdayInput
			v-model="form.birthday"
			@input="onChange"
			data-vv-name="birthday"
			v-validate="modelValidations.birthday"
			:error="errors.first('birthday')"
			required
		></BirthdayInput>
		<LanguageSelect
			:label-text="$t('common.language')"
			v-model="form.language"
			@input="onChange"
			v-validate="modelValidations.language"
			data-vv-name="language"
			:error="errors.first('language')"
			required
		></LanguageSelect>
	</form>
</template>

<script>
import DatePicker from "@/components/templates/DatePicker";
import {validateForm, validateRequiredFields} from "@/validation/validation";
import BirthdayInput from "@/components/templates/common/BirthdayInput";
import LanguageSelect from "@/components/templates/select/LanguageSelect";

export default {
	props: {
		info: { type: Object }
	},
	components: {
		LanguageSelect,
		BirthdayInput,
		DatePicker
	},
	data() {
		return {
			modelValidations: {
				firstName: {
					required: true
				},
				lastName: {
					required: true
				},
				email: {
					required: true,
					email: true
				},
				birthday: {
					required: true,
				},
				language: {
					required: true,
				}
			},
			form: {
				id: null,
				firstName: "",
				lastName: "",
				email: "",
				birthday: "",
				language: "",
			}
		};
	},
	mounted() {
		this.form = { ...this.form, ...this.info };
	},
	computed: {
		isFormValid() {
			return validateRequiredFields(this.form, this.modelValidations);
		},
	},
	methods: {
		onChange() {
			this.$emit("changed", this.form);
		},
	  	validateForm() {
			return validateForm(this, this.$validator);
		}
	},
	watch: {
		info() {
			this.form = { ...this.form, ...this.info };
		}
	},
};
</script>